var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.formatted),function(span,index){return [(!span.isHighlight)?_c('span',{key:index},[_vm._v(_vm._s(span.text))]):_c('span',{key:index,style:({ 'background-color': _vm.highlightBg })},[_vm._v(_vm._s(span.text))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }